import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API_recursos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import {
  FaArrowUpRightFromSquare,
  FaUser,
  FaLocationDot,
  FaCalendarDays,
} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/NuevosRecursos.css";
import { API_BASE_URL } from "../../config/apiConfig";

const RecursoSocial = () => {
  const { id } = useParams();
  const { role } = useSelector((state) => state.auth);
  const [recurso, setRecurso] = useState(null);
  const [loading, setLoading] = useState(true);

  /* Botón eliminar recurso */
  const [mostrarModal, setMostrarModal] = useState(false);
  const navigate = useNavigate();

  const handleCancelar = () => {
    setMostrarModal(true);
  };

  useEffect(() => {
    const fetchRecurso = async () => {
      try {
        const response = await fetch(API_recursos);
        const data = await response.json();
        // Buscar la oferta por _id
        const encontrada = data.find((recurso) => recurso._id === id);
        setRecurso(encontrada || null);
      } catch (error) {
        console.error("Error al obtener el recurso:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRecurso();
  }, [id]);

  const fechaPermanente = (fin) => !fin; // null o ""

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  if (loading) return <p>Cargando recurso...</p>;
  if (!recurso) return <p>No se encontró el recurso.</p>;

  const handleEliminarRecurso = async () => {
    try {
      const res = await fetch(`${API_recursos}/${recurso._id}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error();

      toast.success("Recurso eliminado correctamente", { autoClose: 1500 });
      setMostrarModal(false); // cierra el modal
      setTimeout(() => navigate("/admin/social"), 1500);
    } catch (err) {
      toast.error("No se pudo eliminar el recurso");
      console.error(err);
    }
  };

  return (
    <>
      <Navbar />

      <main className="main ofertas-usuario">
        <section className="cabecera between">
          <div className="column gap-5">
            <h1 className="titulo-user">{recurso.title}</h1>
            <p className="bold font-18 azul">
              #
              {recurso.category.charAt(0).toUpperCase() +
                recurso.category.slice(1).toLowerCase()}
            </p>
          </div>

          <div className="flex gap-10">
            {/* Botones editar y eliminar recurso - solo para administradores y tecnico-1 */}
            {(role === "administrador" || role === "tecnico-1") && (
              <Link
                className="boton"
                to={`/admin/nuevo-recurso-social/${recurso._id}`}
              >
                Editar este recurso social
              </Link>
            )}
            {role === "administrador" && (
              <button
                className="eliminar fondo-rojo blanco"
                onClick={handleCancelar}
              >
                Eliminar este recurso
              </button>
            )}
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column gap-5">
              <p>
                ¿Estás seguro que quieres eliminar el recurso?<br></br>Una vez
                eliminada no habrá forma de recuperarlo
              </p>
              <div className="botones flex gap-20">
                <button
                  className="fondo-rojo blanco"
                  onClick={handleEliminarRecurso}
                >
                  Eliminar recurso
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  Mantener recurso
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="contenido-principal between">
          <div>
            <p className="bold mb-5">
              Recurso publicado el: {formatearFecha(recurso.createdAt)}
            </p>
            <p>{recurso.description}</p>

            {/* Mostrar imagen si existe */}
            {recurso.imagePath && (
              <div className="imagen-recurso mt-20">
                <img
                  src={
                    recurso.imagePath.startsWith("http")
                      ? recurso.imagePath
                      : `${API_BASE_URL}/downloads/recursos-sociales/${recurso.imagePath}`
                  }
                  alt={recurso.title}
                  className="imagen-detalle"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
          </div>

          <div className="caracteristicas column gap-10">
            <p>
              <span className="azul">
                <FaCalendarDays />
              </span>
              {formatearFecha(recurso.featuredStart)} &nbsp;–&nbsp;
              {fechaPermanente(recurso.featuredEnd)
                ? "Permanente"
                : formatearFecha(recurso.featuredEnd)}
            </p>
            <p>
              <span className="azul">
                <FaUser />
              </span>
              Menores de 25 años{/* {recurso.destinatarios} */}
            </p>
            <p>
              <span className="azul">
                <FaLocationDot />
              </span>
              {recurso.location}
            </p>
            {recurso.link && (
              <a
                href={recurso.link}
                target="_blank"
                className="azul align-center"
                rel="noreferrer"
              >
                <span className="azul">
                  <FaArrowUpRightFromSquare />
                </span>
                Link a la información
              </a>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default RecursoSocial;
